export default {
      id: "flex-justifyContent-center-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-justifyContent-center-usage",
      toString: function () {
        return this.url;
      }
    }